import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

const genericDatasetFilterSchema = z.object({
  id: z.string(),
  op: z.enum(["eq", "ne", "gt", "gte", "lt", "lte", "anyof", "in", "contains"]),
  value: z.union([z.string(), z.number(), z.boolean(), z.array(z.union([z.string(), z.number()]))]),
});

export type GenericDatasetFilter = z.infer<typeof genericDatasetFilterSchema>;

const genericDatasetSelectSchema = z.object({
  field: z.string(),
  alias: z.string().optional(),
});

const genericDatasetsQueryRequestSchema = z.object({
  from: z.string(),
  select: z.array(genericDatasetSelectSchema),
  filters: z.array(genericDatasetFilterSchema).optional(),
  limit: z.number().optional(),
  page: z.number().optional(),
});

const genericDatasetsQueryResponseSchema = z.object({
  data: z.array(z.record(z.string(), z.unknown())),
  labels: z.record(z.string(), z.string()),
  pagination: z.object({
    page: z.number(),
    limit: z.number().nullable(),
    total: z.number().nullable(),
  }),
  stats: z.record(z.string(), z.unknown()).nullish(),
});

export const genericDatasetsQueryApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    method: "post",
    path: "/datasets/query/generic/",
    alias: "genericDatasetsQuery",
    description: "Query a dataset by hand-built from/select/filters spec (no date gating, org auto-injected)",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: genericDatasetsQueryRequestSchema,
      },
    ],
    response: genericDatasetsQueryResponseSchema,
  }).build(),
);
